import React from "react";
import { Link, NavLink } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

/**
 * Топ-бар на всех /ideas/* страницах. Гость видит ссылку «Войти»,
 * залогиненный — пункт «Мои идеи» + аватар-кружок.
 */
export default function IdeasTopbar() {
  const { isAuthenticated } = useAuth();
  return (
    <header className="idz-topbar">
      <div className="idz-container">
        <Link to="/" className="idz-brand">
          <span className="idz-brand-logo">R</span>
          Рублокс
        </Link>
        <nav className="idz-topnav">
          <NavLink to="/ideas" end className={({isActive}) => isActive ? "is-active" : ""}>
            Главная
          </NavLink>
          <NavLink to="/ideas/list" className={({isActive}) => isActive ? "is-active" : ""}>
            Все идеи
          </NavLink>
          {isAuthenticated && (
            <NavLink to="/ideas/my" className={({isActive}) => isActive ? "is-active" : ""}>
              Мои
            </NavLink>
          )}
          {/* «В кабинет» убран для авторизованных — навигацию даёт меню
              кабинета слева (IdeasPage обёрнут в CabinetChrome). */}
          {!isAuthenticated && (
            <NavLink to="/login">Войти</NavLink>
          )}
        </nav>
      </div>
    </header>
  );
}
